export default "__VITE_ASSET__B2Tz3g5U__"